import React from 'react';

import { useDispatch, useSelector } from '../../../redux/hooks';
import { setVisible, AlertDrawerActionType, AlertDrawerActionTarget } from '../../../redux/slices/alertsDrawer/alertsDrawer';
import { deleteAlert } from '../../../redux/thunks/alerts';
import Edit from '../../icons/Edit';
import Archive from '../../icons/Archive';
import { ActionsColumnValue } from '../types';
import * as styles from './styles/styles.module.scss';

type ActionsColumnProps = {
  value: ActionsColumnValue;
};

const ActionsColumn = ({ value: { alert, areaId, editUrl } }: ActionsColumnProps): JSX.Element => {
  const alertsDrawerEnabled = useSelector(state => state.enabledFeatures.alertsDrawer);
  const dispatch = useDispatch();
  const onDeleteAlert = async () => {
    if (window.confirm('Are you sure you want to archive this alert?')) {
      await dispatch(deleteAlert({ areaId, alert, trailIds: [] }));
    }
  };

  const editAlert = () => {
    dispatch(
      setVisible({
        visible: true,
        action: AlertDrawerActionType.EDIT,
        target: AlertDrawerActionTarget.AREAS,
        alerts: [alert]
      })
    );
  };

  return (
    <div className={styles.actionIcons}>
      {alertsDrawerEnabled && (
        <button data-testid="edit-alert" className={styles.edit} type="button" onClick={editAlert}>
          <Edit title="Edit alert" />
        </button>
      )}
      {!alertsDrawerEnabled && (
        <a href={editUrl || null} className={styles.edit} target="_blank" rel="noopener noreferrer">
          <Edit title="Edit alert" />
        </a>
      )}
      <button className={styles.archive} type="button" onClick={onDeleteAlert}>
        <Archive title="Archive alert" />
      </button>
    </div>
  );
};

export default ActionsColumn;
